import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { OfferDetailInitStepDeclaration } from "./Steps/OfferDetailInitStep";

export const OfferDetailStartupFlow = new FlowDefinition("OfferDetailFlow");

OfferDetailStartupFlow.addStep(OfferDetailInitStepDeclaration);

OfferDetailStartupFlow.setStartStep("OfferDetailInit_Step");

export const OfferDetailStartupStepDefinition = new StepDefinition({
    stepName: "OfferDetailFlow",
    stepFlow: OfferDetailStartupFlow
})
